<div class="app-container">
  <app-header *ngIf="isLogged$ | async"></app-header>
  <div class="app-container__body">
    <app-sidenav *ngIf="isLogged$ | async"></app-sidenav>
    <main class="app-container__content" [class.app-container__content--logged]="isLogged$ | async">
      <router-outlet></router-outlet>
    </main>
  </div>
  <app-footer *ngIf="isLogged$ | async"></app-footer>
</div>

<app-loader></app-loader>
